var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "circle close"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10 20A10 10 0 1 1 20 10 10 10 0 0 1 10 20ZM10 19A9 9 0 1 0 1.1 10 9 9 0 0 0 10 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined-Shape",
    className: "cls-2",
    d: "M8.6 10 6.5 7.9 7.9 6.5 10 8.6l2.1-2.1 1.4 1.4L11.4 10l2.1 2.1-1.4 1.4L10 11.4 7.9 13.5 6.5 12.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle_close.1bc1ffb76aa1fa0a98be809acdb00e31.svg";
export { ForwardRef as ReactComponent };